import React from 'react'

export default function BannerSection1() {
  return (
    <section className="banner-style-three" style={{ maxWidth: "100vw", width: "100%" }}>
      <div className="pattern-layer">
        {/* <div
          className="pattern pattern-1"
          style={{ backgroundImage: "url(assets/images/icons/pattern-14.png)", backgroundSize: 'cover', backgroundRepeat: 'no-repeat', }}
        /> */}
        <div
          className="pattern pattern-2"
          style={{ backgroundImage: "url(assets/images/icons/pattern-16.png)", transform: 'scaleX(-1)'
           }}
        />
        <div
          className="pattern pattern-3"
          style={{ backgroundImage: "url(assets/images/icons/pattern-16.png)" }}
        />
        
      </div>
      <div className="parallax-scene parallax-scene-2 parallax-icon">
        <span data-depth="0.40"className="parallax-layer" > <img src="assets/sample images/clouds2.png" /> </span>
        <span data-depth="0.50" className="parallax-layer" />
        <span data-depth="0.30" className="parallax-layer" />
      </div>
      <div className="auto-container">
        <div className="row clearfix">
          <div className="col-lg-7 col-md-12 col-sm-12 content-column">
            <div className="content-box">
              <h1 style={{fontSize:"50px"}}>
                 Revolutionizing Heavy Equipment Rentals, One Click at a Time
              </h1>
              <div className="text">
                <p>
                Need heavy equipment? Rent top-quality machines for your project without the
                  <br />
                  long-term commitment . We've got the tools to fuel your success!
                </p>
              </div>
              <div
                className="btn-box clearfix wow slideInUp"
                data-wow-delay="0ms"
                data-wow-duration="1500ms"
              >
                {/* <a
                  href="https://www.youtube.com/watch?v=nfP5N9Yc72A&t=28s"
                  className="lightbox-image video-btn"
                  data-caption=""
                >
                  <i className="fas fa-play" />
                  <span className="border-animation" />
                </a> */}
                <a href="#enquiry" className="theme-btn style-four">
                  Enquire Now
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-md-12 col-sm-12 image-column">
            <div className="image-box">
            {/* <figure className="image image-1 ">
                <img src="assets/sample images/image2.png" alt="" />
              </figure>
              <figure 
                className="image image-2 float-bob-y">
                <img src="assets/sample images/image2.png" style={{ marginTop: '20px' }} alt="" />
              </figure> */}
              <figure className="image image-1 ">
                {/* <img src="assets\sample images\home-u.png" style={{ marginTop: '110px', width: '600px', height: '400px'}} alt="" /> */}
                <img src="assets\sample images\11667738_20945585 [Converted] (1).png" style={{ marginTop: '110px', width: '600px', height: '400px'}} alt="" />
              </figure>
              <figure className="image image-1 wow slideInRight"
                data-wow-delay="0ms"
                data-wow-duration="1500ms"
              >
                {/* <img src="assets/sample images/single2.png" /> */}
                {/* transform: 'scaleX(-1)', overflow: 'hidden' */}
              </figure>
              <figure className="image image-2 float-bob-x">
                <img src="assets/sample images/image1.png" style={{ height: '150px' }}  alt="" />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
